<template>
  <Page class="detailView">
    <div v-if="companyData">
      <div class="pageContent-title">企业信息</div>
      <div class="detailView-with-actions mt-5">
        <a-form class="flex-form" :form="form" :colon="false" labelAlign="left">
          <div class="form-base-width">
            <div>
              <a-form-item label="企业名称" required>
                <a-input
                  v-decorator="[
                    'companyName',
                    {
                      rules: [{ required: true, message: '请输入' }],
                    },
                  ]"
                  :disabled="isView"
                ></a-input>
              </a-form-item>
            </div>
            <!-- <div>
              <a-form-item label="登陆邮箱" required>
                <a-input
                  v-decorator="[
                    'contactEmail',
                    {
                      rules: [{ required: true, message: '请输入' }],
                    },
                  ]"
                  :disabled="isView"
                ></a-input>
              </a-form-item>
            </div> -->
            <div class="flex gap-6" v-if="companyType === 2">
              <div class="flex gap-1">
                <a-form-item label="合作有效期" required>
                  <a-date-picker
                    v-decorator="[
                      'contractStartDate',
                      {
                        rules: [{ required: true, message: '请输入' }],
                      },
                    ]"
                    valueFormat="YYYY-MM-DD"
                    :disabledDate="disabledStartDate"
                    :disabled="isView"
                  >
                    <a-icon type="calendar" slot="suffixIcon"></a-icon>
                  </a-date-picker>
                </a-form-item>
                <div class="pt-2">~</div>
                <a-form-item>
                  <a-date-picker
                    v-decorator="[
                      'contractEndDate',
                      {
                        rules: [{ required: true, message: '请输入' }],
                      },
                    ]"
                    valueFormat="YYYY-MM-DD"
                    :disabledDate="disabledEndDate"
                    :disabled="isView"
                  >
                    <a-icon type="calendar" slot="suffixIcon"></a-icon>
                  </a-date-picker>
                </a-form-item>
              </div>
              <a-form-item label="合同状态" :labelCol="{ style: 'width:80px' }">
                <a-select
                  v-decorator="[
                    'contractStatus',
                    {
                      rules: [{ required: true, message: '请选择' }],
                    },
                  ]"
                  :disabled="isView"
                  :options="typesMap.contractStatus"
                  style="width: 120px"
                ></a-select>
              </a-form-item>
            </div>
            <a-form-item label="类型" required>
              <!-- NOTE (备注)form设置默认值- -->
              <a-select
                class="w-full"
                v-decorator="['companyType', { initialValue: 1 }]"
                placeholder="请选择类型"
                allowClear
                :options="typesMap.companyType"
                :disabled="isView"
                @change="updataCompanyType"
              ></a-select>
            </a-form-item>
            <a-form-item label="业务类型" required v-if="companyType === 2">
              {{
                form.getFieldValue('businessType') === 1
                  ? '签证业务'
                  : form.getFieldValue('businessType') === 2
                  ? '公证业务'
                  : form.getFieldValue('businessType') === 3
                  ? '认证业务'
                  : '签证业务'
              }}
            </a-form-item>
          </div>

          <div v-show="companyType === 2">
            <a-divider></a-divider>
            <div class="text-base font-bold">产品信息配置</div>
            <div class="pl-7">
              <VisaProduct :isView="isView" :companyData="companyData"></VisaProduct>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="结算周期" :labelCol="{ style: 'width:90px' }" required>
                    <div>
                      T+
                      <a-input-number
                        v-decorator="['visaProductSettlementPeeriod']"
                        :precision="0"
                        :min="0"
                        style="width: 50px"
                        :disabled="isView"
                      ></a-input-number>
                      <span class="ml-4 text-red-500">结算周期不能小于0</span>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <!-- <NotarProduct :isView="isView" :companyData="companyData"></NotarProduct> -->
              <!-- <a-form-item label="结算周期" :labelCol="{ style: 'width:90px' }" required>
                <div>
                  T+
                  <a-input-number
                    v-decorator="['notarizationProductSettlementPeriod']"
                    :precision="0"
                    :min="0"
                    style="width: 50px"
                    :disabled="isView"
                  ></a-input-number>
                  <span class="ml-4 text-red-500">结算周期不能小于0</span>
                </div>
              </a-form-item> -->
            </div>
            <a-divider></a-divider>
          </div>

          <div class="text-base font-bold" v-if="companyType === 2">地址配置</div>
          <div
            style="padding: 0 30px; width: 800px; border: 1px solid #dfdfdf; padding-top: 20px; margin-top: 20px"
            class="form-base-width"
            v-if="companyType === 2"
          >
            <a-row :gutter="30">
              <a-col :span="12">
                <a-form-item label="收件人" required>
                  <a-input
                    v-decorator="[
                      'person',
                      {
                        rules: [{ required: true, message: '请输入' }],
                      },
                    ]"
                    placeholder="请输入收件人姓名"
                    :disabled="isView"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="联系电话" required>
                  <a-input
                    v-decorator="[
                      'phoneNumber',
                      {
                        rules: [
                          { required: true, message: '请输入联系电话' },
                          { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                        ],
                      },
                    ]"
                    :disabled="isView"
                    placeholder="请填写手机号"
                  ></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="地址">
              <v-distpicker
                @selected="selected"
                :province="address.province"
                :city="address.city"
                :area="address.region"
                v-decorator="[
                  'region',
                  {
                    rules: [{ required: true, message: '请选择地址' }],
                  },
                ]"
                :disabled="isView"
              ></v-distpicker>
            </a-form-item>
            <a-form-item label="详细信息">
              <a-input
                v-decorator="[
                  'address',
                  {
                    rules: [{ required: true, message: '请输入详细信息' }],
                  },
                ]"
                :disabled="isView"
                placeholder="请填写详细地址"
              ></a-input>
            </a-form-item>
          </div>
          <a-divider></a-divider>
          <a-form-item label="是否支持自送自取：" required v-if="companyType === 2">
            <a-radio-group v-decorator="['isDelivery', { initialValue: false }]" @change="updateGiveAndTake">
              <a-radio :value="true">
                是
              </a-radio>
              <a-radio :value="false">
                否
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <div
            style="padding: 0 30px; width: 800px; border: 1px solid #dfdfdf; padding-top: 20px; margin-top: 20px"
            class="form-base-width"
            v-if="giveAndTake && companyType === 2"
          >
            <a-form-item label="工作时间：" required>
              <a-input
                v-decorator="[
                  'deliveryTime',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="地址：" required>
              <a-input
                v-decorator="[
                  'deliveryAddress',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="电话：" required>
              <a-input
                v-decorator="[
                  'deliveryPhone',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="地图：" required>
              <PictureCardListUpload
                v-decorator="['deliveryAddressPicture', { rules: [{ required: true, message: '请选择地图配图' }] }]"
                :file-list="form.getFieldValue('deliveryAddressPicture')"
                @onremove="onremoveImage('deliveryAddressPicture')"
                @onchange="videoChangeImage($event, 'deliveryAddressPicture')"
                :max-count="1"
                :itemWidth="375"
                :itemHeight="210"
              ></PictureCardListUpload>
            </a-form-item>
          </div>

          <a-divider></a-divider>
          <div class="form-base-width">
            <a-form-item label="联系人" required>
              <a-input
                v-decorator="[
                  'contactPerson',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
                :disabled="isView"
              ></a-input>
            </a-form-item>
            <a-form-item label="联系电话" required>
              <a-input
                v-decorator="[
                  'contactPhoneNumber',
                  {
                    rules: [
                      { required: true, message: '请输入' },
                      { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                    ],
                  },
                ]"
                :disabled="isView"
              ></a-input>
            </a-form-item>
            <div class="relative">
              <a-form-item label="点券" class="relative flex items-center">
                <a-input v-decorator="['preDepositAmount']" disabled></a-input>
              </a-form-item>
              <a-button class="app-btn info-btn absolute top-1 -right-40" @click="checkConsumption">
                <app-icon type="icon-chakan"></app-icon>
                <span>查看消费记录</span>
              </a-button>
            </div>

            <a-form-item label="状态">
              <a-radio-group v-decorator="['isDisable']" :disabled="isView">
                <a-radio :value="0">已启用</a-radio>
                <a-radio :value="1">已禁用</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="back">取消</a-button>
        <a-button class="app-btn" type="primary" @click="doSave">保存</a-button>
      </div>
    </div>
  </Page>
</template>

<script>
import VDistpicker from '@/components/Distpicker/Distpicker'
import Page from '@/components/Page'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import Reg from '@/utils/reg'
import { companyType } from '@/vars'
import NotarProduct from './modules/NotarProduct.vue'
import VisaProduct from './modules/VisaProduct.vue'
import PictureCardListUpload from '@/components/PictureCardListUpload'
import { log } from '@chenfengyuan/vue-qrcode'
export default {
  components: {
    Page,
    VisaProduct,
    NotarProduct,
    VDistpicker,
    PictureCardUpload,
    PictureCardListUpload,
  },
  props: {},
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      // 结算modal
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },
      address: {
        province: '',
        city: '',
        region: '',
      },
      companyType: true,
      giveAndTake: false,
      supplierId: null,
      companyData: null,
      Reg,
    }
  },
  computed: {
    typesMap() {
      return {
        companyType,
        contractStatus: [
          { value: 1, label: '未续约' },
          { value: 2, label: '存续' },
          { value: 3, label: '过期' },
        ],
        businessType: [
          { value: 1, label: '签证' },
          { value: 2, label: '公证' },
          { value: 3, label: '认证' },
        ],
        addressIsTure: [
          { value: 0, label: '未验证' },
          { value: 1, label: '已验证' },
        ],
      }
    },
    isView() {
      return this.$route.query.handleType === 'VIEW'
    },
  },
  methods: {
    onremoveImage(type) {
      this.form.setFieldsValue({
        [type]: [],
      })
    },
    videoChangeImage(obj, type) {
      this.form.setFieldsValue({
        [type]: [obj],
      })
    },
    updataCompanyType(e) {
      this.companyType = e
    },
    updateGiveAndTake(e) {
      this.giveAndTake = e.target.value
    },
    selected(data) {
      this.address.province = data.province.value
      this.address.city = data.city.value
      this.address.region = data.area.value
    },
    disabledStartDate(currentDate) {
      const endDate = this.form.getFieldValue('contractEndDate')
      return endDate && currentDate.isAfter(endDate)
    },
    disabledEndDate(currentDate) {
      const startDate = this.form.getFieldValue('contractStartDate')
      return startDate && currentDate.isBefore(startDate)
    },
    checkConsumption() {
      window.open(`/m/scopeMain/recharge?companyId=${this.$route.query.companyId}`)
    },
    back() {
      this.$router.go(-1)
    },
    doSave() {
      if (this.address.region) {
        this.form.setFieldsValue({
          region: this.address.region,
        })
      }
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          if (params.companyType === 1 && params.isDisable !== 1) {
            this.$message.warning('选择旅行社时, 企业状态请选择已启用')
            return
          }
          if (this.address.region) {
            params.province = this.address.province
            params.city = this.address.city
          }
          try {
            await this.$axios.post('/company/admin/company/save', {
              companyId: this.$route.query.companyId,
              ...params,
              userId: this.companyData.userId
            })
            var addressObj = {
              supplierId: this.supplierId,
              person: params.person,
              phoneNumber: params.phoneNumber,
              province: this.address.province,
              city: this.address.city,
              region: this.address.region,
              address: params.address,
              isDelivery: params.isDelivery,
            }
            if (params.isDelivery) {
              addressObj.deliveryTime = params.deliveryTime
              addressObj.deliveryAddress = params.deliveryAddress
              addressObj.deliveryPhone = params.deliveryPhone
              console.log('deliveryAddressPicture', params.deliveryAddressPicture)
              if (params.deliveryAddressPicture && params.deliveryAddressPicture.length > 0) {
                addressObj.deliveryAddressPicture = params.deliveryAddressPicture[0]
              }
            }
            if (this.companyType === 2) {
              await this.$axios.post('/company/admin/supplier/saveExpressAddress', addressObj)
            }
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async loadById(id) {
      const res = await this.$axios.get('/company/admin/company/queryByCompanyId', {
        params: {
          companyId: id,
        },
      })
      const companyData = res.data
      this.companyData = JSON.parse(JSON.stringify(res.data))
      const fields = JSON.parse(JSON.stringify(res.data))

      if (companyData.supplierInfoDto) {
        this.address.province = companyData.supplierInfoDto.province
        this.address.city = companyData.supplierInfoDto.city
        this.address.region = companyData.supplierInfoDto.region
        fields.address = companyData.supplierInfoDto.address
        fields.phoneNumber = companyData.supplierInfoDto.phoneNumber
        fields.person = companyData.supplierInfoDto.person
        fields.region = companyData.supplierInfoDto.region ? companyData.supplierInfoDto.region : null
        this.supplierId = companyData.supplierInfoDto.supplierId
        fields.isDelivery = companyData.supplierInfoDto.isDelivery ? companyData.supplierInfoDto.isDelivery : null
        this.giveAndTake = companyData.supplierInfoDto.isDelivery == true
        fields.deliveryTime = companyData.supplierInfoDto.deliveryTime ? companyData.supplierInfoDto.deliveryTime : null
        fields.deliveryAddress = companyData.supplierInfoDto.deliveryAddress
          ? companyData.supplierInfoDto.deliveryAddress
          : null
        fields.deliveryPhone = companyData.supplierInfoDto.deliveryPhone
          ? companyData.supplierInfoDto.deliveryPhone
          : null
        fields.deliveryAddressPicture = companyData.supplierInfoDto.deliveryAddressPicture
          ? [companyData.supplierInfoDto.deliveryAddressPicture]
          : null
        fields
      }
      this.companyType = fields.companyType
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.form, fields)
      })
      console.log('fields', fields)
    },
  },
  mounted() {
    const id = this.$route.query.companyId
    if (id) {
      this.loadById(id)
    }
  },
}
</script>

<style lang="less"></style>
